import{a as n}from"./chunk-RAAYCPUM.js";function a(...e){return n(r,e)}var r=(e,t)=>[...e,...t];export{a};
